<div class="home-desktop">
  <sports-component></sports-component>
</div>
<div class="home-mobile">
  <!--  0 => Not Checked-->
  <!--  1 => Pre Checked-->
  <!--  2 => Checked-->

  <!--Slider-->
  <slider [data]="this._DataHelper.homeSliderData" [slideShow]="true" [slideShowTime]="5" [heightMultiper]="1" [objectFit]="'cover'" [isLive]="false"></slider>
  <!--Sports-->

  <div class="story-slider-row">
    <div class="story-slider-box">
      <div class="story-slider-item" [routerLink]="['/fav']" *ngIf="this._UiHelper.favPreMatches.length > 0">
        <div class="story-slider-icon-count">
          <image-loader-utils url="star" extraClasses="story-slider-icon favorited"></image-loader-utils>
          <div class="story-slider-count">
            {{ this._UiHelper.favPreMatches.length }}
          </div>
        </div>
        <div class="story-slider-sport-name">{{ 'Favourites' | t }}</div>
      </div>
      <div
        class="story-slider-item"
        *ngFor="let item of mainData; let i = index"
        [ngClass]="{ selected: item.SportId == selectedSportId }"
        (click)="getCountriesBySportsID(item, i)"
        [routerLink]="['/allsports/' + item.SportId]">
        <div class="story-slider-icon-count">
          <image-loader-utils [url]="this.sportsSvgList[item.SportId]?.svgKey" extraClasses="slidermenusvg"></image-loader-utils>
        </div>
        <div class="story-slider-sport-name">{{ item.SportName }}</div>
      </div>
    </div>
  </div>

  <!--Highlights-->
  <div class="match-row-header highlights">{{ 'Highlights' | t }}</div>
  <prematch-component [oddMarketingValue]="oddMarketingB3000Value" [preMatchobservable]="this.preMatchobservable" [_selectedOdds]="this._selectedOdds"></prematch-component>
  <!--Promotions-->
  <div class="home-promotions">
    <div class="title">Weitere Highlights</div>
    <div class="sliderItem" *ngFor="let i of this._DataHelper.homeSliderData; let _k = index" (click)="goBanner(i)" style="margin-bottom: 10px">
      <img [style.width]="'100%'" src="{{ i.FileName }}" alt="" [style.object-fit]="objectFit" />
    </div>
  </div>
</div>
